import type { FilingActivityItem } from '../types';

export interface FilingActivityGroup {
  obligationType: string;
  items: FilingActivityItem[];
}

/**
 * Group filing-activity items by obligationType for the collapsible client-detail view.
 * Items within a group are newest-first (by periodStart); groups are ordered by their
 * newest item, so the most recently-active obligation sorts first. Pure / UI-only.
 */
export function groupFilingActivity(items: FilingActivityItem[]): FilingActivityGroup[] {
  const byType = new Map<string, FilingActivityItem[]>();
  for (const it of items) {
    const arr = byType.get(it.obligationType) ?? [];
    arr.push(it);
    byType.set(it.obligationType, arr);
  }
  const groups: FilingActivityGroup[] = [];
  for (const [obligationType, arr] of byType) {
    arr.sort((a, b) => b.periodStart.localeCompare(a.periodStart));
    groups.push({ obligationType, items: arr });
  }
  groups.sort((a, b) => b.items[0].periodStart.localeCompare(a.items[0].periodStart));
  return groups;
}
